import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import React from "react";

import {
  DropOffHomeLocIndicator,
  DropOffHomeLocOutletIndicatorEnum
} from "../DropOffHomeLocLabels";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center",
      display: "inline-flex",
      paddingBottom: "0 !important",
      paddingTop: "0 !important"
    },
    displayFlexMarginRight10: {
      marginRight: "10px"
    },
    icon: {
      height: "20px",
      marginRight: 5
    },
    lineOne: {
      paddingBottom: 0,
      paddingTop: 0,
      textAlign: "center"
    },
    root: {
      borderRadius: "8px 8px 0 0",
      fontSize: "13px",
      padding: "5px 0",
      width: "100%"
    },
    rootGreen: {
      backgroundColor: "#B4F2DF",
      border: "1px solid #B4F2DF",
      color: "#246C63"
    },
    rootRed: {
      backgroundColor: "#FFD0D6",
      border: "1px solid #FFD0D6",
      color: "#ec5e77"
    }
  },
  { name: "DropOffHomeLocationOutletStatus" }
);

export interface DropOffHomeLocationOutletStatusProps {
  visible?: boolean;
  status: DropOffHomeLocOutletIndicatorEnum;
  registeredAt?: any;
}

const DropOffHomeLocationOutletStatus: React.FC<DropOffHomeLocationOutletStatusProps> = props => {
  const classes = useStyles(props);

  const { visible = false, status, registeredAt } = props;

  if (!visible) {
    return <></>;
  }

  const formatDate = dateString => moment(dateString).format("MMM DD, YYYY");

  return (
    <Card
      className={
        status === DropOffHomeLocOutletIndicatorEnum.REGISTERED
          ? `${classes.root} ${classes.rootGreen}`
          : `${classes.root} ${classes.rootRed}`
      }
    >
      <CardContent className={classes.content}>
        <DropOffHomeLocIndicator
          status={status}
          className={classes.displayFlexMarginRight10}
          useDarkerShade={true}
        />
        <div
          style={{
            paddingBottom: "0",
            zIndex: 1
          }}
        >
          <div className={classes.lineOne}>
            {status === DropOffHomeLocOutletIndicatorEnum.REGISTERED ? (
              <>
                <span>Registered</span>
                {registeredAt && (
                  <span>
                    {" on "} {formatDate(registeredAt)}
                  </span>
                )}
              </>
            ) : (
              <span>Unregistered</span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DropOffHomeLocationOutletStatus;
